var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-column flex-grow-1 my-4"},[_c('codebook-table',{attrs:{"name":"Typ investiční strategie","type":"InvestmentStrategyType","items":_vm.codebooks,"product-id":_vm.Constants.NreiProductId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }